// src/components/FallbackUI/FallbackUI.jsx
import React from 'react';
import './FallbackUI.css';

const FallbackUI = ({message = 'Loading...'}) => (
    <div className="fb-ui-container d-flex justify-content-center align-items-center min-vh-100">
        <div className="fb-ui-content text-center">
            {/*<Spinner animation="border" role="status" className="fb-ui-spinner">*/}
            {/*    <span className="visually-hidden">{message}</span>*/}
            {/*</Spinner>*/}
            {/*<p className="fb-ui-message mt-3">{message}</p>*/}
        </div>
    </div>
);

export default FallbackUI;
